// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "VideoTranscriptionModal-module--arrow-up-and-down--5d66e";
export var modal = "VideoTranscriptionModal-module--modal--31ae5";
export var modalTitleContainer = "VideoTranscriptionModal-module--modalTitleContainer--8a2e5";
export var modalVideoSubtitle = "VideoTranscriptionModal-module--modalVideoSubtitle--1d061";
export var modalVideoTitle = "VideoTranscriptionModal-module--modalVideoTitle--99f7f";
export var videoTranscriptionContainer = "VideoTranscriptionModal-module--videoTranscriptionContainer--35c0b";
export var videoTranscriptionSupertitle = "VideoTranscriptionModal-module--videoTranscriptionSupertitle--08de8";